<template>
  <div class="content">
    <NavbarShowcase />
    <v-main>
      <v-container fluid>
        <v-card>
          <v-card-title>
            Encuesta de Satisfacción {{ session.route }}
          </v-card-title>
          <v-card-text>
            <div>
              <div class="font-weight-bold">Fecha de la sesión</div>
              <div>{{ filter.formatDate(session.date,1) }}</div>
            </div>
            <div class="mt-3">
              <div class="font-weight-bold">Grupo</div>
              <div>Grupo {{ session.group }}</div>
            </div>
            <div class="mt-3">
              <div class="font-weight-bold">Encuesta</div>
              <div>Por favor dedica unos minutos a responder la siguiente encuesta de satisfacción:</div>
              <div class="mt-3">
                <v-text-field v-model="satisfaction.document" variant="outlined" density="compact" 
                placeholder="Número de documento (Este campo solo acepta números)" 
                onkeypress="return event.charCode>=48 && event.charCode<=57"
                :error-messages="v$.document.$errors.map(e => e.$message)"/>
                <div>Usted considera que el tiempo destinado para la experiencia fue:</div>
                <v-radio-group v-model="satisfaction.question1" :error-messages="v$.question1.$errors.map(e => e.$message)">
                  <v-radio class="text-black" value="5" label="Muy largo" />
                  <v-radio class="text-black" value="3" label="Largo" />
                  <v-radio class="text-black" value="1" label="Adecuado" />
                  <v-radio class="text-black" value="2" label="Corto" />
                  <v-radio class="text-black" value="4" label="Muy corto" />
                </v-radio-group>
                <div>¿Qué tan útil fue el contenido presentado en esta experiencia?</div>
                <v-radio-group v-model="satisfaction.question2" :error-messages="v$.question2.$errors.map(e => e.$message)">
                  <v-radio class="text-black" value="5" label="Extremadamente útil" />
                  <v-radio class="text-black" value="4" label="Muy útil" />
                  <v-radio class="text-black" value="3" label="Algo útil" />
                  <v-radio class="text-black" value="2" label="No muy útil" />
                  <v-radio class="text-black" value="1" label="Para nada útil" />
                </v-radio-group>
                <div>¿Usted considera que el equipo a cargo de la experiencia resolvió sus inquietudes y brindó un ambiente respetuoso durante la sesión?</div>
                <v-radio-group v-model="satisfaction.question3" :error-messages="v$.question3.$errors.map(e => e.$message)">
                  <v-radio class="text-black" value="5" label="Siempre" />
                  <v-radio class="text-black" value="4" label="Casi siempre" />
                  <v-radio class="text-black" value="3" label="Ocasionalmente" />
                  <v-radio class="text-black" value="2" label="Casi nunca" />
                  <v-radio class="text-black" value="1" label="Nunca" />
                </v-radio-group>
                <div>Usted considera que el diseñador que dirigió esta experiencia de formación tiene un dominio de los contenidos:</div>
                <v-radio-group v-model="satisfaction.question4" :error-messages="v$.question4.$errors.map(e => e.$message)">
                  <v-radio class="text-black" value="5" label="Muy alto" />
                  <v-radio class="text-black" value="4" label="Alto" />
                  <v-radio class="text-black" value="3" label="Adecuado" />
                  <v-radio class="text-black" value="2" label="Insuficiente" />
                  <v-radio class="text-black" value="1" label="Nada adecuado" />
                </v-radio-group>
                <div>¿Qué tan satisfecho se encuentra con la metodología y recursos didácticos usados por el diseñador para explicar los contenidos propuestos?</div>
                <v-radio-group v-model="satisfaction.question5" :error-messages="v$.question5.$errors.map(e => e.$message)">
                  <v-radio class="text-black" value="5" label="Muy satisfecho" />
                  <v-radio class="text-black" value="4" label="Satisfecho" />
                  <v-radio class="text-black" value="3" label="Neutral" />
                  <v-radio class="text-black" value="2" label="Insatisfecho" />
                  <v-radio class="text-black" value="1" label="Muy insatisfecho" />
                </v-radio-group>
                <div>¿Usted considera que se cumplió con el objetivo de aprendizaje propuesto para esta experiencia?</div>
                <v-radio-group v-model="satisfaction.question6" :error-messages="v$.question6.$errors.map(e => e.$message)">
                  <v-radio class="text-black" value="5" label="Totalmente de acuerdo" />
                  <v-radio class="text-black" value="4" label="De acuerdo" />
                  <v-radio class="text-black" value="3" label="Ni deacuerdo ni en desacuerdo" />
                  <v-radio class="text-black" value="2" label="En desacuerdo" />
                  <v-radio class="text-black" value="1" label="Totalmente en desacuerdo" />
                </v-radio-group>
                <div>En general, ¿qué tan satisfecho se encuentra usted con esta experiencia?</div>
                <v-radio-group v-model="satisfaction.question7" :error-messages="v$.question7.$errors.map(e => e.$message)">
                  <v-radio class="text-black" value="5" label="Muy satisfecho" />
                  <v-radio class="text-black" value="4" label="Satisfecho" />
                  <v-radio class="text-black" value="3" label="Neutral" />
                  <v-radio class="text-black" value="2" label="Insatisfecho" />
                  <v-radio class="text-black" value="1" label="Muy insatisfecho" />
                </v-radio-group>
                <div>¿Dónde pondrá en práctica lo aprendido en esta experiencia?</div>
                <v-radio-group v-model="satisfaction.question8" :error-messages="v$.question8.$errors.map(e => e.$message)">
                  <v-radio class="text-black" value="5" label="En el área o asignatura que acompaño" />
                  <v-radio class="text-black" value="4" label="En el proyecto/prototipo que estoy desarrollando" />
                  <v-radio class="text-black" value="3" label="Para trabajar con mi equipo y enriquecer las labores profesionales" />
                  <v-radio class="text-black" value="2" label="Para mi desarrollo personal" />
                  <v-radio class="text-black" value="1" label="No lo he definido" />
                </v-radio-group>
                <v-btn color="primary" variant="flat" text="Enviar" @click="send()"/>
              </div>
            </div>
            
          </v-card-text>
        </v-card>
      </v-container>
    </v-main>

    <!-- success -->
    <v-dialog v-model="success.state" persistent max-width="500">
      <v-sheet class="pa-4 text-center mx-auto" elevation="12" max-width="600" rounded="lg" width="100%">
        <v-icon class="mb-5" color="success" icon="mdi-check-circle" size="112" />
        <h2 class="text-h5 mb-6">Encuesta de Satisfacción</h2>
        <p class="mb-4 text-medium-emphasis text-body-2">
          {{ success.text }}
        </p>
        <div class="text-center">
          <v-btn class="text-none" color="success" variant="flat" text="Aceptar" @click="back()"/>
        </div>    
      </v-sheet>
    </v-dialog>

    <!-- error -->
    <v-dialog v-model="error.state" persistent max-width="500">
      <v-sheet class="pa-4 text-center mx-auto" elevation="12" max-width="600" rounded="lg" width="100%">
        <v-icon class="mb-5" color="error" icon="mdi-close-circle" size="112" />
        <h2 class="text-h5 mb-6">Encuesta de Satisfacción</h2>
        <p class="mb-4 text-medium-emphasis text-body-2">
          {{ error.text }}
        </p>
      </v-sheet>
    </v-dialog>

    <!-- failed -->
    <v-dialog v-model="failed" persistent max-width="500">
      <v-sheet class="pa-4 text-center mx-auto" elevation="12" max-width="600" rounded="lg" width="100%">
        <v-icon class="mb-5" color="error" icon="mdi-calendar-remove" size="112" />
        <h2 class="text-h5 mb-3">Parece que ha ocurrido un error</h2>
        <p class="mb-4 text-medium-emphasis text-body-2">
          Esta sesión se encuentra cerrada o no tiene encuesta de satisfacción habilitada.
        </p>
        <div class="text-center">
          <v-btn class="text-none" color="error" variant="plain" prepend-icon="mdi-open-in-new" text="www.unitedwaycolombia.org" @click="openlink('https://unitedwaycolombia.org')"/>
        </div>
      </v-sheet>
    </v-dialog>

    <!-- Process -->
    <v-dialog v-model="process" max-width="320" persistent >
      <v-list class="py-2" color="primary" elevation="12" rounded="lg" >
        <v-list-item prepend-icon="mdi-clock" title="Espera..." >
          <template v-slot:prepend>
            <div class="pe-4">
              <v-icon color="primary" size="x-large"></v-icon>
            </div>
          </template>
          <template v-slot:append>
            <v-progress-circular color="primary" indeterminate="disable-shrink" size="16" width="2" />
          </template>
        </v-list-item>
      </v-list>
    </v-dialog>
  </div>
</template>
<script setup>
  import NavbarShowcase from '../components/navbar/NavbarShowcase';
  import axios from 'axios';
  import Params from '@/models/params';
  import Satisfaction from "@/models/satisfaction";
  import Session from '@/models/session';
  import Filters from '@/models/filters';
  import { ref, reactive, computed, onMounted } from "vue";
  import { useRoute } from 'vue-router';
  import { useVuelidate } from '@vuelidate/core';
  import { required, numeric, minLength, maxLength, helpers } from '@vuelidate/validators';

  const route = useRoute();

  const success = reactive({
    state: false,
    text: null
  })

  const error = reactive({
    state: null,
    text: null
  })

  const satisfaction = reactive(new Satisfaction)
  const params = ref(new Params)  
  const session = ref(new Session)
  const filter = ref(new Filters)

  const process = ref(true);
  const failed = ref(false);

  session.value.code = route.params.session;

  const rules = computed(() => {
    return {
      document: {
        required: helpers.withMessage('Campo requerido.', required), 
        numeric: helpers.withMessage('Solo números.', numeric), 
        minLength: helpers.withMessage('Mínimo 6 números.', minLength(5)), 
        maxLength: helpers.withMessage('Máximo 15 números.', maxLength(15)), 
      },
      question1: { required: helpers.withMessage('Campo requerido.', required) },
      question2: { required: helpers.withMessage('Campo requerido.', required) },
      question3: { required: helpers.withMessage('Campo requerido.', required) },
      question4: { required: helpers.withMessage('Campo requerido.', required) },
      question5: { required: helpers.withMessage('Campo requerido.', required) },
      question6: { required: helpers.withMessage('Campo requerido.', required) },
      question7: { required: helpers.withMessage('Campo requerido.', required) },
      question8: { required: helpers.withMessage('Campo requerido.', required) }
    }
  })

  const v$ = useVuelidate(rules, satisfaction)

  async function load(){
    const frm = new FormData;
    frm.append("action","cargar");
    frm.append("sesion",session.value.code);
    frm.append("tipo","S");
    const result = await eject(frm);
    process.value = false;
    if(result.data.length > 0){
      session.value.setDataAsisstance(result.data[0]);
    }else{
      failed.value = true;
    }
  }

  async function send(){
    if(!await v$.value.$validate()){
      return
    }
    process.value = true;
    const frm = new FormData;
    frm.append("action","satisfaccion");
    frm.append("sesion",session.value.code);
    frm.append("data",JSON.stringify(satisfaction));
    const result = await eject(frm);
    process.value = false;
    if(result.state){
      switch (result.data[0].response) {
        case 0:
          error.text = "No te encuentras matrículado en este grupo.";
          error.state = true;
          break;
        case 1:
          error.text = "Ya se encuentra registrada por favor no volver a enviar el registro.";
          error.state = true;
          break;
        case 2:
          success.text = "Encuesta registrada correctamente.";
          success.state = true;
          break;
      }      
    }else{
      error.text = "Hubo un error al intentar registrar la encuesta.";
      error.state = true;
    }
  }

  function back(){
    window.history.back();
  }

  function eject(f){
    return new Promise((resolve) => {
      axios.post(params.value.controller + 'encuesta.php',f)
      .then(res => {
        resolve(res.data)
      })
      .catch(() => {
        resolve(null)
      })
    })
  }

  onMounted(() => {
    load();
  })

</script>